import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import TurintechWorkflow from './TurintechWorkflow';
import SimplifiedMlWorkflow from './components/evoml/SimplifiedMlWorkflow';
import ArtemisIntelligenceDiagram from './components/artemis/ArtemisIntelligence';
import MultiObjectiveOptimisation from './components/artemis/MultiObjectiveOptimisation';
import Roadmap from './components/artemis/Roadmap';
import EvoMLRoadmap from './components/evoml/EvoMLRoadmap';
import EvoMLArchitecture from './components/evoml/EvoMLArchitecture';
import EvoMLDeployment from './components/evoml/EvoMLDeployment';
import EvoMLGovernance from './components/evoml/EvoMLGovernance';
import ArtemisOverview from './components/artemis/ArtemisOverview';
import ArtemisUniqueness from './components/artemis/ArtemisUniqueness';
import ArtemisDecisionPlatform from './components/agents/ArtemisDecisionPlatform';
import ArtemisGeneration_Tests from './components/artemis/ArtemisGeneration_Tests';
import ArtemisGeneration_Benchmarks from './components/artemis/ArtemisGeneration_Benchmarks';
import ArtemisGeneration_Applications from './components/artemis/ArtemisGeneration_Applications';
import OpenAIExample from './components/chat/OpenAIExample';
import Navigation from './components/Navigation';
import ArtemisApproaches from './components/artemis/ArtemisApproaches';
import IntellectualPropertyProtection from './components/IntellectualPropertyProtection';
import EvoMLIntellectualProperty from './components/evoml/EvoMLIntellectualProperty';
import ArtemisIntellectualProperty from './components/artemis/ArtemisIntellectualProperty';
import ArtemisSDLC from './components/artemis/ArtemisSDLC';
import EvoMLSDLC from './components/evoml/EvoMLSDLC';
import Summary from './components/Summary';

// Placeholder components for new pages
import EvoMLUseCases from './components/evoml/EvoMLUseCases';
import EvoMLIntegrations from './components/evoml/EvoMLIntegrations';
import ArtemisUseCases from './components/artemis/ArtemisUseCases';
import ArtemisIntegrations from './components/artemis/ArtemisIntegrations';
import ArtemisArchitecture from './components/artemis/ArtemisArchitecture';
import ArtemisGovernance from './components/artemis/ArtemisGovernance';
import EvolutionaryApproach from './components/agents/EvolutionaryApproach';
import DecisionMakerPlatform from './components/agents/DecisionMakerPlatform';
import AgentsDecisionMaking from './components/agents/AgentsDecisionMaking';
import TurintechAutoFeedback from './components/agents/TurintechAutoFeedback';
import AgentOrchestration from './components/agents/AgentOrchestration';
import OptimizationApproaches from './components/agents/OptimizationApproaches';
import AgentOptimisation from './components/agents/AgentOptimisation';
import FileSplitLLM from './components/artemis/FileSplitLLM';
import ArtemisIntelligenceVsBigModels from './components/artemis/ArtemisIntelligenceVsBigModels';
import ArtemisSoftwareEvolution from './components/artemis/ArtemisSoftwareEvolution';
import ArtemisEvolution from './components/artemis/ArtemisEvolution';
import AutomatedMlWorkflow from './components/evoml/AutomatedMlWorkflow';
import Vision from './components/vision/Vision';

// Features
import { RunnerSettings } from './features/runner-settings';

// Admin
import PromptManagement from './components/admin/PromptManagement';

function App() {
  return (
    <Router>
      <div style={{ fontFamily: 'Arial, sans-serif', paddingBottom: '50px' }}>
        <Navigation />
        
        <Routes>
          <Route path="/" element={<Summary />} />
          <Route path="/summary" element={<Summary />} />
          
          
          {/* Vision */}
          <Route path="/vision" element={
            <div style={{ width: '100%', padding: '0' }}>
              <Vision />
            </div>
          } />
          
          {/* EvoML Routes */}
          <Route path="/evoml-workflow-simplified" element={
            <div style={{ width: '100%', padding: '0' }}>
              <SimplifiedMlWorkflow title="EvoML Platform - Simplified View" />
            </div>
          } />
          <Route path="/evoml-sdlc" element={
            <div style={{ width: '100%', padding: '0' }}>
              <EvoMLSDLC />
            </div>
          } />
          <Route path="/evoml-use-cases" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <EvoMLUseCases />
            </div>
          } />
          <Route path="/evoml-integrations" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <EvoMLIntegrations />
            </div>
          } />
          <Route path="/evoml-architecture" element={
            <div style={{ width: '100%', padding: '0' }}>
              <EvoMLArchitecture title="EvoML SaaS Platform Architecture" />
            </div>
          } />
          <Route path="/evoml-deployment" element={
            <div style={{ width: '100%', padding: '0' }}>
              <EvoMLDeployment />
            </div>
          } />
          <Route path="/evoml-governance" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <EvoMLGovernance />
            </div>
          } />
          <Route path="/evoml-ip-protection" element={
            <div style={{ width: '100%', padding: '0' }}>
              <EvoMLIntellectualProperty />
            </div>
          } />
          <Route path="/evoml-roadmap" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <EvoMLRoadmap title="EvoML Platform: 12-Month Roadmap" />
            </div>
          } />
          <Route path="/evoml-automated-workflow" element={
            <div style={{ width: '100%', padding: '0' }}>
              <AutomatedMlWorkflow title="AI-Automated Data Science Workflow with EvoML & Artemis" />
            </div>
          } />
          
          {/* Artemis Routes */}
          <Route path="/artemis-overview" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisOverview />
            </div>
          } />
          <Route path="/artemis-sdlc" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisSDLC />
            </div>
          } />
          <Route path="/artemis-uniqueness" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisUniqueness />
            </div>
          } />
          <Route path="/artemis-intelligence-vs-big-models" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisIntelligenceVsBigModels />
            </div>
          } />
          <Route path="/artemis-approaches" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisApproaches />
            </div>
          } />
          <Route path="/artemis-file-split" element={
            <div style={{ width: '100%', padding: '0' }}>
              <FileSplitLLM />
            </div>
          } />
          <Route path="/artemis-use-cases" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <ArtemisUseCases />
            </div>
          } />
          <Route path="/artemis-integrations" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <ArtemisIntegrations />
            </div>
          } />
          <Route path="/artemis-architecture" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <ArtemisArchitecture />
            </div>
          } />
          <Route path="/artemis-governance" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <ArtemisGovernance />
            </div>
          } />
          <Route path="/artemis-software-evolution" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisSoftwareEvolution />
            </div>
          } />
          <Route path="/artemis-evolution" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisEvolution />
            </div>
          } />
          <Route path="/artemis-ip-protection" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisIntellectualProperty />
            </div>
          } />
          <Route path="/artemis-roadmap" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <Roadmap title="Artemis Project: 12-Month Roadmap" />
            </div>
          } />
          
          {/* Agents Routes */}
          <Route path="/agents-turintech-approach" element={
            <div style={{ width: '100%', padding: '0' }}>
              <EvolutionaryApproach />
            </div>
          } />
          <Route path="/agents-platforms" element={
            <div style={{ width: '100%', padding: '0' }}>
              <DecisionMakerPlatform />
            </div>
          } />
          <Route path="/agents-decision-making" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisDecisionPlatform />
            </div>
          } />
          <Route path="/agents-artemis-evolution" element={
            <div style={{ width: '100%', padding: '0' }}>
              <ArtemisUniqueness />
            </div>
          } />
          <Route path="/turintech-auto-feedback" element={
            <div style={{ width: '100%', padding: '0' }}>
              <TurintechAutoFeedback />
            </div>
          } />
          <Route path="/agent-orchestration" element={
            <div style={{ width: '100%', padding: '0' }}>
              <AgentOrchestration />
            </div>
          } />
          <Route path="/agent-optimisation" element={
            <div style={{ width: '100%', padding: '0' }}>
              <AgentOptimisation />
            </div>
          } />
          <Route path="/optimization-approaches" element={
            <div style={{ width: '100%', padding: '0' }}>
              <OptimizationApproaches />
            </div>
          } />
          
          {/* Tools */}
          <Route path="/openai" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <OpenAIExample />
            </div>
          } />
          
          {/* Features */}
          <Route path="/runner-settings" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <RunnerSettings />
            </div>
          } />
          
          {/* Admin */}
          <Route path="/admin/prompts" element={
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
              <PromptManagement />
            </div>
          } />
          
          {/* IP Protection */}
          <Route path="/ip-protection" element={
            <div style={{ width: '100%', padding: '0' }}>
              <IntellectualPropertyProtection />
            </div>
          } />
          
          {/* Legacy routes - redirect to new structure */}
          <Route path="/traditional" element={<Navigate to="/evoml-workflow-simplified" replace />} />
          <Route path="/turintech" element={<Navigate to="/agents-turintech-approach" replace />} />
          <Route path="/artemis" element={<Navigate to="/artemis-overview" replace />} />
          <Route path="/evoml" element={<Navigate to="/evoml-workflow-simplified" replace />} />
          <Route path="/evoml-workflow" element={<Navigate to="/evoml-workflow-simplified" replace />} />
          <Route path="/evoml-workflow-detailed" element={<Navigate to="/evoml-workflow-simplified" replace />} />
          <Route path="/evoml-turintech-workflow" element={<Navigate to="/evoml-workflow-simplified" replace />} />
          <Route path="/artemis-test-gen" element={<Navigate to="/artemis-use-cases" replace />} />
          <Route path="/artemis-benchmark" element={<Navigate to="/artemis-use-cases" replace />} />
          <Route path="/artemis-app-builder" element={<Navigate to="/artemis-use-cases" replace />} />
          <Route path="/artemis-intel-ga" element={<Navigate to="/agents-turintech-approach" replace />} />
          <Route path="/multi-objective" element={<Navigate to="/agents-turintech-approach" replace />} />
          <Route path="/artemis-uniqueness-old" element={<Navigate to="/artemis-uniqueness" replace />} />
          <Route path="/artemis-decision" element={<Navigate to="/agents-decision-making" replace />} />
          <Route path="/project-roadmap" element={<Navigate to="/artemis-roadmap" replace />} />
        </Routes>
        
      </div>
    </Router>
  );
}

export default App;
